/**
 * TODO: Avoid diffing by passing individual values into a React component
 * rather than the whole `store`, and letting React and `shouldComponentUpdate`
 * handle diffing for us.
 */
export function equals(a, b) {
  if (isImmutable(a) && isImmutable(b)) {
    return a.equals(b);
  }

  return a === b;
}
export function isImmutable(a) {
  return !!a && typeof a === 'object' && ('@@__IMMUTABLE_ITERABLE__@@' in a || '@@__IMMUTABLE_RECORD__@@' in a);
}
export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
} // Strict Object.keys

export function keys(o) {
  return Object.keys(o);
}
export function mapValues(o, f) {
  var result = {};
  keys(o).forEach(function (k) {
    return result[k] = f(o[k], k);
  } // TODO: Improve this
  );
  return result;
}
export function some(o, f) {
  return keys(o).some(function (k) {
    return f(o[k], k);
  });
}